export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";